import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function registerEmployee(form) {
    const payload = {
        registrationRequest: {
            username: form.username,
            name: form.name,
            surname: form.surname,
            oib: form.oib,
            address: form.address,
            email: form.email,
            telephone: form.telephone,
            role: form.role,
            dateOfBirth: form.dateOfBirth,
        },
        employee: {
            iban: form.iban,
            availableVacationDays: Number(form.availableVacationDays),
            dateOfBirth: form.dateOfBirth,
            citizenship: form.citizenship,
            placeOfBirth: form.placeOfBirth,
            jobPositionId: Number(form.jobPositionId),
            departmentId: Number(form.departmentId),
            employmentStatusId: Number(form.employmentStatusId),
            salary: Number(form.salary),
            gender: form.gender,
        },
    };

    const formData = new FormData();
    formData.append("data", new Blob([JSON.stringify(payload)], { type: "application/json" }));
    if (form.contract) {
        formData.append("contract", form.contract);
    }

    const response = await apiFetch(API_ENDPOINTS.EMPLOYEE, {
        method: "POST",
        credentials: "include",
        body: formData,
    });

    if (response.status !== 201) {
        const data = await response.json();
        throw new Error(data.message || "Greška pri dodavanju zaposlenika");
    }

    return await response.json();
}

export async function searchEmployees(query, page = 0, size = 10) {
    const params = new URLSearchParams({
        query,
        page,
        size,
    });

    const response = await apiFetch(
        `${API_ENDPOINTS.EMPLOYEE}/search?${params.toString()}`,
        {
            method: "GET",
            credentials: "include",
        }
    );

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška pri pretraživanju zaposlenika");
    }

    return await response.json();
}

export async function getEmployeeById(id) {
    const response = await apiFetch(`${API_ENDPOINTS.EMPLOYEE}/${id}`, {
        method: "GET",
        credentials: "include",
    });

    if (!response.ok) {
        let data;
        try {
            data = await response.json();
        } catch {
            data = {};
        }
        throw new Error(data.message || "Greška kod dohvaćanja zaposlenika");
    }

    return await response.json();
}

export async function updateEmployee(id, employeeData, contractFile) {
    const payload = {
        ...employeeData,
        jobPositionId: Number(employeeData.jobPositionId) || null,
        departmentId: Number(employeeData.departmentId) || null,
        employmentStatusId: Number(employeeData.employmentStatusId) || null,
    };
    const formData = new FormData();
    formData.append(
        "data",
        new Blob([JSON.stringify(payload)], { type: "application/json" })
    );
    if (contractFile) formData.append("contract", contractFile);

    const response = await apiFetch(`${API_ENDPOINTS.EMPLOYEE}/${id}`, {
        method: "PUT",
        credentials: "include",
        body: formData,
    });

    if (!response.ok) {
        let data;
        try {
            data = await response.json();
        } catch {
            data = {};
        }
        throw new Error(data.message || "Greška kod ažuriranja zaposlenika");
    }

    return await response.json();
}
